import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "LIST-VOCA" }
const _hoisted_2 = { id: "ACTION" }
const _hoisted_3 = { class: "flex justify-between flex-wrap space-y-2 md:space-y-0 navigation mb-2" }
const _hoisted_4 = { class: "flex justify-end space-x-2" }
const _hoisted_5 = { id: "CONTENT " }
const _hoisted_6 = {
  key: 0,
  id: "DIRECTION",
  class: "flex justify-center md:justify-end px-2 mt-4"
}

import LearnEnglishPagePatternLayout from "../LearnEnglishPagePatternLayout.vue";
import ModalVocabularyAdd from "@/components/learn-english/vocabulary/ModalVocabularyAdd.vue";
import TableVocabulariesComponent from "@/components/learn-english/vocabulary/TableVocabulariesComponent.vue";
import SearchFilter from "@/components/learn-english/vocabulary/SearchFilter.vue";
import { ref, onMounted, watchEffect } from "vue";

import {
  IVocabularyRequest,
  IVocabulariesResponse,
  IVocabulary,
} from "@/models/IIearnEnglish";
import {
  changeSpecial,
  deleteVoca,
  getAllVocabularies,
  updateVocabulary,
} from "@/api/vocabularyApi";
import {
  IS_DELETED,
  ORDER_BY,
  PAGE_FIRST,
  PAGE_SIZE_DEFAULT,
  QUERY_DEFAULT,
} from "@/utils/global";
import ModalVocabularyEdit from "@/components/learn-english/vocabulary/ModalVocabularyEdit.vue";
import i18n from "@/services/i18n";
import { PlusOutlined } from "@ant-design/icons-vue";
import { useRouter } from "vue-router";
import { getLoadingGet } from "@/utils/loadingUtils";
import DateRangePicker from "@/components/learn-english/vocabulary/DateRangePicker.vue";

// States

export default /*@__PURE__*/_defineComponent({
  __name: 'ListVocabulary-page',
  setup(__props) {

const isSelectPractice = ref(false);
const showModalVoabularyAdd = ref(false);
const vocaEdit = ref<IVocabulary | null>(null);
const vocabulariesResponse = ref<IVocabulariesResponse>();
const vocabularyRequest = ref<IVocabularyRequest>({
  query: QUERY_DEFAULT,
  page: PAGE_FIRST,
  pageSize: PAGE_SIZE_DEFAULT + 10,
  is_deleted: IS_DELETED.is_False,
  orderBy: {
    column: ORDER_BY.COLUMN_DEFAULT,
    order: ORDER_BY.ORDER_DEFAULT,
  },
  startDate: "",
  endDate: "",
});
const loadedPages = ref<{ [key: number]: IVocabulariesResponse }>({});

const handleSearch = (value: string) => {
  vocabularyRequest.value.query = value;
  vocabularyRequest.value.page = 1;
  loadedPages.value = {};
  handleFetchVocabulary();
};

const handlePageChange = (page: number) => {
  vocabularyRequest.value.page = page;
  handleFetchVocabulary();
};

const handlePageSizeChange = ({
  current,
}: {
  current: { current: number; pageSize: number };
}) => {
  vocabularyRequest.value.page = current.current;
  vocabularyRequest.value.pageSize = current.pageSize;
  loadedPages.value = {};
  handleFetchVocabulary();
};

const handleChangeSpecical = async (o: IVocabulary) => {
  const currentPage = vocabularyRequest.value.page;
  if (currentPage !== undefined && loadedPages.value[currentPage]) {
    const currentPageData = loadedPages.value[currentPage].data?.results;
    currentPageData?.forEach(async (item, index) => {
      if (item.id === o.id) {
        currentPageData[index] = {
          ...item,
          is_special: !item.is_special,
        };
        try {
          if (item.id !== undefined) {
            await changeSpecial(item.id);
          }
        } catch (error) {
          console.error(error);
        }
      }
    });
  }
};

const handleDelete = async (o: IVocabulary) => {
  const currentPage = vocabularyRequest.value.page;
  if (currentPage !== undefined && loadedPages.value[currentPage]) {
    const currentPageData = loadedPages.value[currentPage].data?.results;
    if (currentPageData) {
      const indexToRemove = currentPageData.findIndex(
        (item) => item.id === o.id
      );
      if (indexToRemove !== -1) {
        currentPageData.splice(indexToRemove, 1);
        try {
          if (o.id !== undefined) {
            await deleteVoca(o.id);
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  }
};

const handleUpdate = async (o: IVocabulary) => {
  try {
    if (o.id) {
      await updateVocabulary(o.id, o);
      vocaEdit.value = null;
    }
  } catch (error) {
    console.error(error);
  }
};

const handleFetchVocabulary = async () => {
  const currentPage = vocabularyRequest.value.page;
  if (currentPage !== undefined && loadedPages.value[currentPage]) {
    vocabulariesResponse.value = loadedPages.value[currentPage];
    return;
  }
  try {
    const response = await getAllVocabularies(vocabularyRequest.value);
    vocabulariesResponse.value = response;
    if (currentPage !== undefined) {
      loadedPages.value[currentPage] = response;
    }
  } catch (error) {
    console.error(error);
  }
};

const router = useRouter();

const goToPracticePage = () => {
  router.push({ name: "PracticeVocaPage" });
};

const handleDateChange = (startDate: string, endDate: string) => {
  vocabularyRequest.value.startDate = startDate;
  vocabularyRequest.value.endDate = endDate;
  vocabularyRequest.value.page = 1;
  loadedPages.value = {};
  handleFetchVocabulary();
};

onMounted(() => {
  handleFetchVocabulary();
});

watchEffect(() => {
  handleFetchVocabulary();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LearnEnglishPagePatternLayout, {
    title: _unref(i18n).global.t('VOCABULARY_SECTION.LIST_LABEL')
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(SearchFilter, { onSearch: handleSearch }),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "flex items-center gap-1 px-3 py-1.5 rounded-lg bg-gradient-to-br from-blue-500 to-gray-600 text-white hover:bg-blue-700 shadow transition-all duration-200",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showModalVoabularyAdd.value = true))
              }, [
                _createVNode(_unref(PlusOutlined), { class: "text-base flex items-center" }),
                _createElementVNode("span", null, _toDisplayString(_unref(i18n).global.t("VOCABULARY_SECTION.ADD_BUTTON")), 1)
              ]),
              _createElementVNode("button", {
                class: "flex items-center gap-1 px-3 py-1.5 rounded-lg bg-gray-100 text-black hover:bg-gray-300 shadow transition-all duration-200",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (isSelectPractice.value = !isSelectPractice.value))
              }, [
                _createElementVNode("span", null, _toDisplayString(!isSelectPractice.value
                      ? _unref(i18n).global.t("VOCABULARY_SECTION.SELECT_PRACTICE")
                      : _unref(i18n).global.t("VOCABULARY_SECTION.UNSELECT_PRACTICE")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(DateRangePicker, { onDateChange: handleDateChange })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(TableVocabulariesComponent, {
            "is-select-practice": isSelectPractice.value,
            "page-info": vocabulariesResponse.value?.data,
            vocabularyList: vocabulariesResponse.value?.data?.results,
            onChangeSpecial: handleChangeSpecical,
            onPageChange: handlePageChange,
            onPageSizeChange: handlePageSizeChange,
            onDelete: handleDelete,
            onEdit: _cache[2] || (_cache[2] = 
              (o) => {
                vocaEdit.value = o;
              }
            )
          }, null, 8, ["is-select-practice", "page-info", "vocabularyList"])
        ])
      ]),
      (!_unref(getLoadingGet)())
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: goToPracticePage,
              class: "px-5 py-2 bg-white hover:bg-gray-200 text-black font-semibold rounded-lg flex items-center gap-2 shadow"
            }, [
              _cache[7] || (_cache[7] = _createElementVNode("svg", {
                class: "w-5 h-5",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  d: "M5 12h14M12 5l7 7-7 7",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t("VOCABULARY_SECTION.START_PRACTICE")), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (showModalVoabularyAdd.value)
        ? (_openBlock(), _createBlock(ModalVocabularyAdd, {
            key: 1,
            modelValue: showModalVoabularyAdd.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = 
          ($event) => {
            showModalVoabularyAdd.value = $event;
            loadedPages.value = {};
            handleFetchVocabulary();
          }
        ),
            onClosenoload: _cache[4] || (_cache[4] = ($event: any) => (showModalVoabularyAdd.value = false)),
            onClose: _cache[5] || (_cache[5] = ($event: any) => (showModalVoabularyAdd.value = false))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (vocaEdit.value ? true : false)
        ? (_openBlock(), _createBlock(ModalVocabularyEdit, {
            key: 2,
            "model-value": vocaEdit.value ? true : false,
            "vocabulary-to-edit": vocaEdit.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = 
          (o) => {
            vocaEdit.value = o.o;

            if (o.loading && vocaEdit.value) {
              handleUpdate(vocaEdit.value);
              loadedPages.value = {};
              handleFetchVocabulary();
            }
          }
        )
          }, null, 8, ["model-value", "vocabulary-to-edit"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})